import script from "./ReferencesBrowse.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReferencesBrowse.vue?vue&type=script&lang=ts&setup=true"

import "./ReferencesBrowse.vue?vue&type=style&index=0&id=2e59cbe8&lang=scss"

const __exports__ = script;

export default __exports__
import QTree from 'quasar/src/components/tree/QTree.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTree});
